module.exports = __webpack_public_path__ + "static/banner-083d83a4d19d324a9967318b32acaa03.png";